<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CircularProgressBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    strokeColor: {
      type: String,
      default: '#22ac8a',
    },
    bgColor: {
      type: String,
      default: '#ffffff',
    },
    speed: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    circleStyle() {
      return {
        borderRadius: '50%',
        width: "36px",
        height: "36px",
        background: `conic-gradient(${this.strokeColor} ${this.value * 3.6}deg, ${this.bgColor} ${this.value * 3.6}deg)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
})
</script>

<template>
  <div class="circular-progress" :style="circleStyle">
    <slot />
  </div>
</template>

<style scoped lang="scss">

</style>